import {AdminPagingModel} from "./AdminPagingModel";
import {User} from "../../entities/User";
import {UserService} from "../../services/UserService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";

export class UserAdminPagingModel extends AdminPagingModel<User>{
    static $inject = ['$q','UserService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:UserService,notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "user";
    }
    displayName():string{
        return "Users";
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['username', 'Username', 150],
                ['firstName', 'First Name', 215],
                ['lastName', 'Last Name', 215],
                ['email', 'Email', 215],
                ['phone', 'Phone', 215],
                ['viewOnly', 'View Only', 215],
                ['companyName', 'Company Name', 215]
            ];
        return this.$q.when();
    }
}
